/**
 * Provides utility functions that wrap formatting utilities like
 * Intl.NumberFormat or Intl.DateFormat with sensible, site-wide defaults
 */

/** Format a number as currency */
export const formatCurrency = (
  value: number,
  currency: string,
  options?: Omit<Intl.NumberFormatOptions, 'style' | 'currency'>,
): string =>
  Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options,
    style: 'currency',
    currency,
  }).format(value)

/** Format a number as USD */
export const formatUSD = (
  value: number,
  options?: Omit<Intl.NumberFormatOptions, 'style' | 'currency'>,
): string => formatCurrency(value, 'USD', options)

/** Format a list of items in a text with  */
export const formatTextList = (
  list: string[],
  options?: Partial<Intl.ListFormatOptions>,
): string => {
  return new Intl.ListFormat('en-US', {
    style: 'long',
    type: 'conjunction',
    ...options,
  }).format(list)
}
